// extracted by mini-css-extract-plugin
export default {"squareAvatar":"Avatar_squareAvatar__ZTdat","mdRoundedAvatar":"Avatar_mdRoundedAvatar__sDUqv"};